/* eslint-disable */
import gsap from 'gsap';

export default function initCarouselBlockQuoteSection() {
    document.querySelectorAll('.carousel-blockquote-section').forEach(( carouselSection ) => {
        const transtime = (carouselSection.querySelector('.blockquote-container').dataset.transitionTime || 1000) / 1000;
        const timeout = (carouselSection.querySelector('.blockquote-container').dataset.timeout || 5000) / 1000;
        const carouselItems = carouselSection.querySelectorAll('.blockquote-item');
        const carouselBtns = carouselSection.querySelectorAll('.carousel-nav__item');
        const timeline = gsap.timeline({ paused: true , repeat: -1 });
        timeline.add('start', '+=0');

        const init = function() {
            carouselBtns.forEach((btn, index) => {
                const indicator = btn.querySelector('.carousel-nav__item-indicator');
                const curr = index * timeout;
                const title = 'item' + index;
                const thisQuote = carouselItems[index];
                const prevQuote = carouselItems[index - 1] || carouselItems[carouselItems.length - 1];
                const prevBtn = carouselBtns[index - 1] || carouselBtns[carouselBtns.length - 1];

                gsap.set(thisQuote, { autoAlpha: 0 });
                timeline.add( title , 'start+=' + curr );
                timeline.to( indicator , {alpha:1 , duration:0.0001} , title + '+=0' );
                timeline.to(thisQuote, { autoAlpha: 1, duration: transtime, ease: "power4.inOut" }, title + '+=0' );
                timeline.to(prevQuote, { autoAlpha: 0, duration: transtime, ease: "power4.inOut" }, title + '+=0' );
                timeline.to(prevBtn.querySelector('.carousel-nav__item-indicator'), { alpha:0, duration: transtime , ease: 'none'}, title + '+=0');
                timeline.fromTo(indicator, { scaleX: 0 }, { scaleX: 1, transformOrigin: 'left', duration: timeout, ease: "power1.out" }, title + '+=0'  );

                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    showItem( e.currentTarget.dataset.index );
                });
            });

            carouselSection.addEventListener('focusin', () => {
                timeline.pause();
            });
            carouselSection.addEventListener('focusout', () => {
                timeline.play();
            });

            carouselSection.style.visibility = 'visible';
            timeline.play();

            window.addEventListener('resize', () => {
                handeOnResize( carouselSection );
            });
            handeOnResize( carouselSection );
        }

        const showItem = function(index) {
            timeline.pause();

            carouselBtns.forEach((btn, btnIndex ) => {
                const indicator = btn.querySelector('.carousel-nav__item-indicator');
                const thisQuote = carouselItems[btnIndex];

                if( index == btnIndex ) {
                    gsap.fromTo(indicator, 0.5 , { alpha: 0, scaleX: 1 } , { alpha: 1, scaleX: 1 });
                    gsap.fromTo(thisQuote, 0.5, { autoAlpha: 0 }, { autoAlpha: 1 });
                } else {
                    gsap.set(indicator, { alpha: 0, scaleX: 0 });
                    gsap.to(thisQuote, 0.5, { autoAlpha: 0 });
                }
            });
        }

        const handeOnResize = function( sect ) {
            const cont = sect.querySelector('.blockquote-container');
            const items = sect.querySelectorAll('.blockquote-item');

            let tallest = 0;
            items.forEach((item) => {
                if (item.offsetHeight > tallest) {
                    tallest = item.offsetHeight;
                }
            });

            cont.style.height = tallest + 'px';
        }

		init();
    });
}
